export enum StatusIndicadorAlerta {
    ABERTO = 0,
    AO_INCLUIR =1,
    PEDENTE_POSTO =2,
	PENDENTE_VALIDACAO=3,
	FECHADO=4
}